import { render, staticRenderFns } from "./FormTextBlock.vue?vue&type=template&id=326e4380"
import script from "./FormTextBlock.vue?vue&type=script&lang=js"
export * from "./FormTextBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports